function makeid(){
  if(typeof window?.crypto?.randomUUID === 'function'){
    return window.crypto.randomUUID();
  }else{
    return weakid(32)
  }
}

function weakid(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}

export {makeid}